// import { FC } from 'react'
// import clsx from 'clsx'
// import { Link } from 'react-router-dom'
// import { useLocation } from 'react-router'
// import { checkIsActive, KTIcon, WithChildren } from '../../../../helpers'
// import { useLayout } from '../../../core'

// type Props = {
//   to: string
//   title: string
//   icon?: string
//   fontIcon?: string
//   hasBullet?: boolean
// }

// const SidebarMenuItem: FC<Props & WithChildren> = ({
//   children,
//   to,
//   title,
//   icon,
//   fontIcon,
//   hasBullet = false,
// }) => {
//   const { pathname } = useLocation()
//   const isActive = checkIsActive(pathname, to)
//   const { config } = useLayout()
//   const { app } = config

//   return (
//     <div className='menu-item'>
//       <Link
//         className={clsx('menu-link without-sub', { active: isActive })}
//         to={to}
//         style={{ ...(isActive && { backgroundColor: '#BFD7ED', color: 'black' }) }}
//       >
//         {hasBullet && (
//           <span className='menu-bullet'>
//             <span className='bullet bullet-dot'></span>
//           </span>
//         )}
//         {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
//           <span className='menu-icon'>
//             {' '}
//             <KTIcon iconName={icon} className='fs-2' />
//           </span>
//         )}
//         {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
//           <i className={clsx('bi fs-3', fontIcon)}></i>
//         )}
//         <span className={`menu-title ${isActive && 'text-black'}`}>{title}</span>
//       </Link>
//       {children}
//     </div>
//   )
// }

// export { SidebarMenuItem }




import { FC } from 'react'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router'
import { checkIsActive, KTIcon, WithChildren } from '../../../../helpers'
import { useLayout } from '../../../core'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
}

const SidebarMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
}) => {
  const { pathname } = useLocation()
  const isActive = checkIsActive(pathname, to)
  const { config } = useLayout()
  const { app } = config

  // Check if icon is an image file
  const isImageIcon = icon && (icon.includes('.png') || icon.includes('.jpg') || icon.includes('.jpeg') || icon.includes('.gif'))

  return (
    <div className='menu-item'>
      <Link
        className={clsx('menu-link without-sub', { active: isActive })}
        to={to}
        style={{ ...(isActive && { backgroundColor: '#BFD7ED', color: 'black' }) }}
      >
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}

        {/* SVG Icon */}
        {icon && !isImageIcon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
          <span className='menu-icon'>
            <KTIcon iconName={icon} className='fs-2' />
          </span>
        )}

        {/* Image Icon */}
        {isImageIcon && (
          <span className='menu-icon'>
            <img
              src={icon}
              alt={title}
              style={{
                width: '24px',
                height: '24px',
                objectFit: 'contain'
              }}
            />
          </span>
        )}

        {/* Font Icon */}
        {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
          <i className={clsx('bi fs-3', fontIcon)}></i>
        )}

        <span className={`menu-title ${isActive && 'text-black'}`}>{title}</span>
      </Link>
      {children}
    </div>
  )
}

export { SidebarMenuItem }
